// src/components/chat/ChatAddParticipantModal.jsx
import React, { useState } from 'react';
import { Modal, Form, Button, Spinner, Alert, ListGroup } from 'react-bootstrap';
import { useChat } from '../../contexts/ChatContext';
import { usersAPI } from '../../services/api';

const ChatAddParticipantModal = ({ show, onHide, roomId, onParticipantAdded }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState('');
  const { addParticipant } = useChat();

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;
    setSearching(true);
    try {
      const data = await usersAPI.getUsers({ search: searchTerm.trim(), limit: 10 });
      const usersList = data.users || data.data || data;
      setSearchResults(Array.isArray(usersList) ? usersList : []);
    } catch (err) {
      console.error('Error searching users:', err);
    } finally {
      setSearching(false);
    }
  };

  const handleAdd = async () => {
    if (!selectedUser) {
      setError('Выберите пользователя');
      return;
    }
    setLoading(true);
    setError('');
    const success = await addParticipant(roomId, selectedUser.id);
    if (success) {
      onParticipantAdded();
      onHide();
    } else {
      setError('Не удалось добавить участника');
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-person-plus me-2"></i>
          Добавить участника
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group className="mb-3">
          <Form.Label>Поиск пользователя</Form.Label>
          <div className="d-flex gap-2">
            <Form.Control
              type="text"
              placeholder="Имя или username"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
            <Button variant="outline-primary" onClick={handleSearch} disabled={searching}>
              {searching ? <Spinner animation="border" size="sm" /> : 'Поиск'}
            </Button>
          </div>
        </Form.Group>

        {searchResults.length > 0 && (
          <ListGroup className="mb-3">
            {searchResults.map(user => (
              <ListGroup.Item
                key={user.id}
                action
                active={selectedUser?.id === user.id}
                onClick={() => setSelectedUser(user)}
              >
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-person-circle"></i>
                  <div>
                    <div>{user.name}</div>
                    <small className="text-muted">@{user.telegram_username || 'нет username'}</small>
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Отмена
        </Button>
        <Button variant="primary" onClick={handleAdd} disabled={!selectedUser || loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Добавить'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChatAddParticipantModal;